import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../datasource/api";
import { AxiosError } from "axios";
import routesName from "../../constants/routesName";
import { AsyncAccessTokenDecoder1 } from "../../utils/accessTokenDecoder";

export const getAllFeedback = createAsyncThunk(
  "get/allfeedback",
  async (
    data: {
      order: string;
      orderBy: string;
      searchQuery?: string;
      page: number;
      rowsPerPage: number;
      searchKeywords?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const decodeToken = await Promise.resolve(AsyncAccessTokenDecoder1());

      const response = await API.get(
        `Feedback/feedback?order=${data.order}&orderBy=${data.orderBy
        }${data.searchQuery ?? ""}&page=${data.page + 1}&pageSize=${data.rowsPerPage
        }&searchKeywords=${data?.searchKeywords}&userId=${decodeToken?.userId}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);
